<template>
  <div>
    <v-alert v-model="errorAlert" dismissible dense outlined type="error">
      <span> {{ errorMsg }} </span>
    </v-alert>
    <p class="top-header">
      <router-link :to="{ name: 'checker_accounts' }"
        ><v-icon class="cursor--pointer">mdi-reply</v-icon></router-link
      >
      {{ $t("AddChecker") }}
      <v-btn
        small
        class="text-capitalize float-right"
        color="primary"
        dark
        :loading="creating"
        @click="createChecker()"
        ><v-icon class="mr-2" small>mdi-plus</v-icon> {{ $t("Create") }}</v-btn
      >
    </p>
    <hr />
    <v-sheet class="mt-2">
      <v-form class="main-form pa-3" ref="form">
        <v-container>
          <v-row>
            <v-col cols="12" sm="4">
              <v-text-field
                :label="$t('Name')"
                v-model="checker.name"
                dense
                outlined
                :rules="[rules.required]"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="4">
              <v-text-field
                :label="$t('LastName')"
                v-model="checker.lastName"
                dense
                outlined
                :rules="[rules.required]"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="4">
              <v-text-field
                label="Email"
                v-model="checker.email"
                dense
                outlined
                :rules="[rules.required, rules.email]"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="4">
              <v-text-field
                :label="$t('Password')"
                v-model="checker.password"
                dense
                outlined
                type="password"
                :rules="[rules.required, rules.pass]"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="4">
              <v-text-field
                :label="`${$t('Confirm')} ${$t('Password')}`"
                v-model="checker.password1"
                dense
                outlined
                :rules="[rules.required, passwordMatch]"
                type="password"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="4">
              <v-text-field
                :label="$t('Phone')"
                v-model="checker.phone"
                dense
                outlined
                :rules="[rules.required]"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-container>
      </v-form>
    </v-sheet>
  </div>
</template>
<script>
import RestResourceAuth from "@/api/apiAuthService";
import { ResponseStatus } from "@/models/ResponseStatusEnum";

export default {
  name: "CheckerCreate",
  data() {
    return {
      creating: false,
      checker: {
        name: "",
        lastName: "",
        email: "",
        password: "",
        password1: "",
        language: "",
        phone: ""
      },
      errorAlert: false,
      errorMsg: "",
      rules: {
        email: v => {
          const re = /^(([^<>()[\]\\.`,{//=!}*^&%#;:\s@"]+(\.[^<>()[\]\\.`,{//=!}*^&%#;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          if (re.test(v)) return true;
          return this.$t("errors.mustBeValidEmail");
        },
        required: v => {
          if (v) {
            return true;
          }
          return this.$t("errors.requiredField");
        },
        pass: v => v.length >= 8 || this.$t("errors.shortPassword")
      }
    };
  },
  computed: {
    passwordMatch() {
      return () =>
        this.checker.password === this.checker.password1 ||
        this.$t("errors.passMustMatch");
    }
  },
  methods: {
    createChecker() {
      if (this.$refs.form.validate()) {
        const body = Object.assign({}, this.checker);
        this.creating = true;
        RestResourceAuth.prototype
          .addChecker(body)
          .then(response => {
            if (response?.status == ResponseStatus.POST_OK) {
              this.$router.push({ name: "checker_accounts" });
            }
            this.creating = false;
          })
          .catch(error => {
            this.errorMsg = error.response.data.message;
            this.errorAlert = true;
            this.creating = false;
          });
      }
    }
  }
};
</script>
<style></style>
